/* eslint-disable */
import { Dispatch, SetStateAction } from 'react';
import { If } from '../Atoms/Conditionals';
import {
  ATC_REGIMES,
  AtctabsData,
  CALCULATOR_DATA,
  SHOW_CALCULATION,
  TAX_REGIMES,
  tabsData,
} from './types';
import IncomeTaxTables from './IncomeTaxTables';
interface TABSWITCH_PROPS {
  tabsData: tabsData | AtctabsData;
  activeTab: number;
  classes?: string;
  setActiveTab: Dispatch<SetStateAction<number>>;
  showSlabsTable?: boolean;
  commonProps?: {
    hasError?: boolean;
    setGlobalError?: Dispatch<SetStateAction<boolean>>;
    inputTabData?: CALCULATOR_DATA;
    setInputData?: Dispatch<SetStateAction<CALCULATOR_DATA>>;
    showCalculation?: SHOW_CALCULATION;
    setShowCalculation?: Dispatch<SetStateAction<SHOW_CALCULATION>>;
    taxCalculation?: TAX_REGIMES | ATC_REGIMES;
    activeTab?: number;
  };
  taxData?: TAX_REGIMES;
}

function isTaxRegimes(obj: unknown): obj is TAX_REGIMES {
  return (
    typeof obj === 'object' && obj != null && 'isOldSchemeSuggested' in obj
  );
}

export const TabSwitch = ({
  tabsData,
  activeTab,
  classes = '',
  setActiveTab,
  commonProps,
  showSlabsTable,
  taxData,
}: TABSWITCH_PROPS) => {
  const activeStyles = tabsData.tabStyles?.activeStyle || '';
  const inactiveStyles = tabsData.tabStyles?.inActiveStyle || '';
  const newSchemeTab = 0;
  const oldSchemeTab = 1;
  const atcNewSchemeTab = 1;
  const atcOldSchemeTab = 0;
  const getTabClassNames = (tabId: number) => {
    return activeTab === tabId ? activeStyles : inactiveStyles;
  };

  const handleTabClick = (tabIndex: number) => {
    setActiveTab(tabIndex);
  };

  const RenderComponent = tabsData.tabs[activeTab]?.component || (() => <></>);
  const taxCalculation = commonProps?.taxCalculation;
  let recommendedTab: number;
  if (isTaxRegimes(taxCalculation)) {
    recommendedTab = taxCalculation?.isOldSchemeSuggested
      ? oldSchemeTab
      : newSchemeTab;
  } else {
    recommendedTab =
      taxCalculation?.preferredRegime === 'New Regime'
        ? atcNewSchemeTab
        : atcOldSchemeTab;
  }

  return (
    <>
      <div
        className={`flex border-b mb-6 sm:mb-[10px] w-fit gap-2 sm:w-full sm:overflow-scroll ${classes}`}
      >
        {tabsData?.tabs?.map((tab) => (
          <>
            <div
              key={tab.index}
              className={getTabClassNames(tab.index)}
              onClick={() => handleTabClick(tab.index)}
            >
              {tab.label}
              <If condition={!!taxCalculation && recommendedTab === tab.index}>
                <div className="bg-green-150 rounded-sm text-green-400 text-s-12 px-1.5 sm:px-1 h-5">
                  Recommended
                </div>
              </If>
            </div>
          </>
        ))}
      </div>
      <div className="mt-4">
        {
          // @ts-ignore
          <RenderComponent {...(commonProps as TAX_REGIMES | ATC_REGIMES)} />
        }
        <If condition={!!!showSlabsTable && activeTab === 0 && !taxData}>
          <IncomeTaxTables />
        </If>
      </div>
    </>
  );
};
